import React, { Component } from 'react';
import { CURRENT_PRICE_USD } from '../utils/currency';
export const MetaPixel = () => {
  // Componente vacío - pixel removido
  return null;
};
// Función para rastrear el evento "Add to Cart" de Facebook Pixel
export const trackAddToCart = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    // @ts-ignore
    fbq('track', 'AddToCart', {
      content_name: 'Guía Contra el Mal de Ojo',
      content_category: 'Ebook',
      content_ids: ['46923986239723'],
      content_type: 'product',
      value: CURRENT_PRICE_USD,
      currency: 'USD'
    });
  }
};